import { render, staticRenderFns } from "./OtherCases.vue?vue&type=template&id=1ede54fa&scoped=true"
import script from "./OtherCases.vue?vue&type=script&lang=js"
export * from "./OtherCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede54fa",
  null
  
)

export default component.exports